<template>
  <div id="product">
    <div class="header flex-between">
      <div class="header-text">
        <h1>产品偏好</h1>
      </div>
      <div class="header-button">
        <el-button icon="iconfont icon-chuangjian1">新增</el-button>
      </div>
    </div>
    <div>
      <el-card shadow="never">
        <el-table
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
        >
          <el-table-column type="index" width="40"></el-table-column>
          <el-table-column prop="name" label="中文描述"> </el-table-column>
          <el-table-column prop="name" label="英文描述"> </el-table-column>
          <el-table-column prop="name" label="创建人"> </el-table-column>
          <el-table-column prop="name" label="创建时间"> </el-table-column>
          <el-table-column prop="name" label="最后修改人"> </el-table-column>
          <el-table-column prop="name" label="最后修改时间"> </el-table-column>
          <el-table-column label="操作">
            <el-button style="border: 0" icon="el-icon-edit-outline" size="mini"
              >修改</el-button
            >
            <el-button
              style="border: 0"
              icon="el-icon-circle-check"
              @click="changeStatus"
              size="mini"
              v-if="btnStatus == 0"
              >启用</el-button
            >
            <el-button
              style="border: 0"
              icon="el-icon-circle-close"
              @click="changeStatus"
              size="mini"
              v-show="btnStatus == 1"
              >禁用</el-button
            >
          </el-table-column>
        </el-table>
        <div class="card-pagination">
          <el-pagination
            background
            :page-size="4"
            layout="total, prev, pager, next"
            :total="400"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "centre",
  data() {
    return {
      btnStatus: 0,
      formInline: {
        user: "",
        region: "",
      },
      tableData: [
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
        {
          name: "王小虎",
        },
      ],
    };
  },
  methods: {
    // 按钮的启用与禁用
    changeStatus() {
      this.btnStatus = this.btnStatus === 0 ? 1 : 0;
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
#product {
  height: 1400px;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}

.card-pagination {
  margin-top: 20px;
  text-align: right;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
}
</style>
